'use strict';var ceil=Math.ceil;var floor=Math.floor;// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports=Math.trunc||function trunc(x){var n=+x;return(n>0?floor:ceil)(n);};